import { Directive, Input, OnChanges, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
  selector: '[appInputNumber]'
})

export class InputNumberDirective implements OnChanges {

  @Input() appInputNumber: FormControl;
  value: number;

  // explanation of regex
  // regex TL;DR - restrict to a positive number with up to two decimals
  rx = new RegExp(/^\d?\d+(?:\.\d{0,2})?$/);

  constructor() { }

  ngOnChanges() {
    this.value = this.appInputNumber.value;
    this.appInputNumber.valueChanges.subscribe(nextValue => {
      if (this.rx.test(nextValue) || nextValue === '') {
        this.value = nextValue;
      } else {
        this.appInputNumber.setValue(this.value, {emitEvent: false});
      }
    });
  }

  @HostListener('blur') onBlur() {
    let val = this.appInputNumber.value;
    const lastChar = val[val.length - 1];
    const secondToLastChar = val[val.length - 2];
    if (lastChar === '.') { val = `${val}00`; }
    if (secondToLastChar === '.') { val = `${val}0`; }
    this.appInputNumber.setValue(val, {emitEvent: false});
  }

}
